import "./About.css";

import Absa from "../../assets/images/absa.svg";
import AckermansLogo from "../../assets/images/Ackermans_retailer.jpg";
import BuildersLogo from "../../assets/images/Builders_retailer.jpg";
import Capitec from "../../assets/images/capitec.svg";
import Checkers from "../../assets/images/Checkers_retailer.jpg";
import FNB from "../../assets/images/fnb.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "../../components/Footer/Footer";
import GameLogo from "../../assets/images/Game_retailer.png";
import Header from "../../components/Header/Header";
import MakroLogo from "../../assets/images/Makro_retailer.png";
import Mastercard from "../../assets/images/mc_symbol.svg";
import Nedbank from "../../assets/images/nedbank-money-svg.svg";
import PepLogo from "../../assets/images/PEP_Primary_Logo.png";
import PicknPayLogo from "../../assets/images/PicknPay_retailer.jpg";
import Shoprite from "../../assets/images/Shoprite_retailer.jpg";
import Snapscan from "../../assets/images/snapscan.svg";
import SparLogo from "../../assets/images/Spar_retailer.jpg";
import StandardBank from "../../assets/images/standard-bank.png";
import Visa from "../../assets/images/Visa_logo.jpg";
import Zapper from "../../assets/images/zapper.svg";
import appConfig from "../../config";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";

const About = () => {
  const navigate = useNavigate();

  const onPayNowClicked = () => {
    navigate("/");
  };

  return (
    <div className="networks-container">
      <Header />
      <div className="networks-hero">
        <p className="hero-title">PayThat, A Faster Way To Pay, Not Drive.</p>
        <p className="hero-subtitle">Safe and effortless ways to settle your traffic fines.</p>
        <p className="hero-desc">
          Fines quickly accumulate, so to handle the hardship of paying them,{" "}
          <a
            href="https://payat.co.za/"
            target="_blank"
            style={{ textDecoration: "none", color: "#e97700" }}
          >
            Pay@
          </a>{" "}
          in collaboration with The City of Cape Town has developed PayThat, a payment solution
          enabling you to pay your traffic fines more safely and swiftly.
        </p>
      </div>
      <div className="how-container">
        <p className="how-heading">How PayThat came to be.</p>
        <br />
        <p className="how-subheading">
          Since 2007, Pay@ has given users and billers in South Africa convenient online and offline
          payment options. In winning the tender, they met and exceeded the City of Cape Towns'
          criteria to be the chosen payment partner, enabling traffic fines to be settled
          effortlessly. This led to the development of PayThat, a secure way to pay traffic fines,
          overseen by a reputable brand known for its excellent service.
        </p>
        <br />
      </div>
      <div className="how-to-container">
        <div className="how-to-copy">
          <p className="how-to-heading">How it works.</p>
          <p className="how-to-subheading">
            Watch the video to see how quick and easy it is to pay your (dreaded) traffic fines.
          </p>
        </div>
        <iframe
          className="how-to-video"
          src={appConfig.howToVideoURL}
          title="PayThat - Traffic fines"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        {/*  */}
        {/*  */}
      </div>
      <div className="about-content-container">
        <p className="networks-heading">Select a PayThat solution listed below.</p>

        <div className="pay-online-section">
          <p className="pay-online-heading">PAY ONLINE</p>
          <div className="network-options">
            <div className="network-item">
              <img src={Visa} />
              <p>Visa</p>
            </div>
            <div className="network-item">
              <img src={Mastercard} />
              <p>Mastercard</p>
            </div>
            <div className="network-item">
              <img src={Absa} />
              <p>ABSA</p>
            </div>
            <div className="network-item">
              <img src={StandardBank} />
              <p>Standard Bank</p>
            </div>
            <div className="network-item">
              <img src={FNB} />
              <p>FNB</p>
            </div>
            <div className="network-item">
              <img src={Nedbank} />
              <p>Nedbank</p>
            </div>
            <div className="network-item">
              <img src={Capitec} />
              <p>Capitec</p>
            </div>

            <div className="network-item">
              <img src={Zapper} />
              <p>Zapper</p>
            </div>

            <div className="network-item">
              <img src={Snapscan} />
              <p>SnapScan</p>
            </div>
          </div>
          <div className="pay-now-button" onClick={() => onPayNowClicked()}>
            <p>Pay Now</p>
            <FontAwesomeIcon className="back-button" icon={faArrowRight} size="3x" color="white" />
          </div>
        </div>
        <div className="about-divider" />
        <div className="pay-in-person-section">
          <p className="pay-online-heading">PAY IN PERSON </p>
          <div className="fines-issued-container">
            <br />
            <p className="fines-issued-heading" style={{ fontWeight: "bold" }}>
              Fines issued prior to July 1, 2022
            </p>
            <img
              src={SparLogo}
              alt=""
              style={{
                marginTop: "10%",
                marginBottom: "10%",
                backgroundColor: "white",
                paddingLeft: 15,
                paddingRight: 15,
              }}
            />
          </div>
          <div className="fines-issued-container">
            <p className="fines-issued-heading" style={{ fontWeight: "bold" }}>
              Fines issued after July 1, 2022
            </p>
            <div className="fines-issued-images">
              <img src={AckermansLogo} alt="" />
              <img src={BuildersLogo} alt="" />
              <img src={GameLogo} alt="" />
              <img
                src={MakroLogo}
                alt=""
                style={{
                  backgroundColor: "white",
                  paddingLeft: 10,
                  paddingRight: 10,
                  paddingBottom: 5,
                  paddingTop: 5,
                }}
              />
              <img src={PepLogo} alt="" style={{ backgroundColor: "white" }} />
              <img
                src={PicknPayLogo}
                alt=""
                style={{
                  backgroundColor: "white",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              />
              <img
                src={SparLogo}
                alt=""
                style={{
                  backgroundColor: "white",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              />
              <img
                src={Shoprite}
                alt=""
                style={{
                  backgroundColor: "white",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              />
              <img
                src={Checkers}
                alt=""
                style={{
                  backgroundColor: "white",
                  paddingLeft: 15,
                  paddingRight: 15,
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
